import { useState } from 'react';
import { t } from '@lingui/macro';
import { useTheme } from '@emotion/react';
import { PaperPlaneTilt } from '@phosphor-icons/react';

import { AccessControl } from 'modules/accessControl/components/AccessControl';
import { useFeatureFlag } from 'modules/accessControl/hooks/useFeatureFlag';
import { GuidedOnboardingWizard } from './GuidedOnboardingWizard';
import { Tooltip } from 'components/tooltip/Tooltip';
import { IconButton } from 'components/button/IconButton';

/**
 * Send-invite icon for the topbar invite-code chip, plus the invite-only wizard it opens.
 * It lives in the suppliers feature and is injected into the topbar from the route layer:
 * `components/topbar` may not import a feature (see docs/architecture-tests.md).
 */
export const SendInviteAction = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const isBrandSupplierConnections = useFeatureFlag('BrandSupplierConnections');

  if (!isBrandSupplierConnections) return null;

  return (
    <AccessControl write scope="suppliers" fallback={null}>
      <>
        <Tooltip title={t`Send invite code`}>
          <div>
            <IconButton
              data-testid="send-invite"
              size="lg"
              aria-label={t`Send invite code`}
              onClick={() => setOpen(true)}
            >
              <PaperPlaneTilt size={18} color={theme.palette.border.accentPrimary} />
            </IconButton>
          </div>
        </Tooltip>
        <GuidedOnboardingWizard open={open} mode="inviteOnly" onClose={() => setOpen(false)} />
      </>
    </AccessControl>
  );
};
